import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts'

import {
  SelectTrigger,
  SelectValue,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
} from 'src/components/shadcn/select'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from 'src/components/shadcn/chart'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'src/components/shadcn/card'
import { useHomeCharBar } from 'src/components/HomeCharBar/useHomeCharBar'

export function HomeCharBar() {
  const {
    setActiveChart,
    activeChart,
    chartConfig,
    total,
    chartData,
    locale,
    currency,
    localCode,
    views,
    period,
    handleSetPeriod,
    periods,
  } = useHomeCharBar()

  return (
    <Card>
      <CardHeader className="flex flex-col items-stretch space-y-0 border-b p-0 sm:flex-row">
        <div className="flex flex-1 flex-col justify-center gap-1 px-6 py-5 sm:py-6">
          <CardTitle className="text-2xl">{locale.title}</CardTitle>
          <div className="flex flex-row gap-1.5 items-center">
            <CardDescription>{locale.subTitle}</CardDescription>
            <Select value={period.toString()} onValueChange={handleSetPeriod}>
              <SelectTrigger className="w-[50px] select-no-arrow">
                <SelectValue defaultValue={period} />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {periods.map((period: string) => {
                    return (
                      <SelectItem key={period} value={period}>
                        {period}
                      </SelectItem>
                    )
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
            <CardDescription>{locale.month}</CardDescription>
          </div>
        </div>
        <div className="flex">
          {views.map(key => {
            const chart = key as keyof typeof chartConfig

            return (
              <button
                key={chart}
                data-active={activeChart === chart}
                className="relative z-30 flex flex-1 flex-col justify-center gap-1 border-t px-6 py-4 text-left even:border-l data-[active=true]:bg-muted/95 sm:border-l sm:border-t-0 sm:px-8 sm:py-6"
                onClick={() => setActiveChart(chart)}
              >
                <span className="text-[14px] text-muted-foreground">
                  {chartConfig[chart].label}
                </span>
                <span className="text-lg font-bold leading-none sm:text-2xl">
                  {total[key as keyof typeof total].toLocaleString()}
                </span>
                <span className="text-lg font-bold leading-none sm:text-2xl">
                  {currency.toUpperCase()}
                </span>
              </button>
            )
          })}
        </div>
      </CardHeader>
      <CardContent className="px-2 sm:p-6">
        <ChartContainer
          config={chartConfig}
          className="aspect-auto h-[250px] w-full"
        >
          <BarChart
            accessibilityLayer
            data={chartData}
            margin={{
              left: 12,
              right: 12,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              minTickGap={32}
              tickFormatter={value => {
                const date = new Date(value)

                return date.toLocaleDateString(localCode, {
                  month: 'short',
                  day: 'numeric',
                })
              }}
            />
            <ChartTooltip
              content={
                <ChartTooltipContent
                  className="w-[150px]"
                  nameKey="views"
                  currency={currency}
                  labelFormatter={value =>
                    new Date(value).toLocaleDateString(localCode, {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                    })
                  }
                />
              }
            />
            <Bar dataKey={activeChart} fill={`var(--color-${activeChart})`} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
